import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';
import { PROD } from 'utils/constants';
import { SignupTrack } from './types';

export const trackSignupEvent = (properties: SignupTrack) => {
  const envObj = process.env;
  const isProd = envObj.NODE_ENV === PROD;
  if (isProd) {
    Analytics.sendEvent(EVENTS.SIGNUP_NEW, properties, 'CDB', properties?.email);
  }
};
